






















































import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { checkMobile } from '../utils/utils'
import Header from './organisms/Header.vue'
import Footer from './organisms/Footer.vue'
import { ROUTER_NAME } from '../router'
import { LETTER_FORMAT } from '../utils/constants'
import ChartProgress from './atoms_molecules/ChartProgress.vue'
import { makeChannel } from '../../../action_cable/cable'
import { userState } from '../stores/user'
import { notificationState } from '../stores/notification'
import { examState } from '../stores/exam'
import { footerState } from '../stores/footer'
import { examTestState } from '../stores/exam_test'
import { snackBarState } from '../stores/snackbar'
import { menuState } from '../stores/menu'
import { examResultState } from '../stores/exam_result'
import { subscriptionState } from '../stores/subscription'
import { examMyState } from '../stores/exam_my'

// 開発環境でのみVue Devtoolsを有効にします。
if (process.env.NODE_ENV === 'development') {
  Vue.config.devtools = true;
}

@Component({
  components: {
    Header,
    Footer,
    ChartProgress
  }
})
export default class ImportComponent extends Vue {
  LETTER_FORMAT = LETTER_FORMAT
  ROUTER_NAME = ROUTER_NAME
  transitionName = 'fade'
  mobile = false
  show: boolean = false

  // Reactivityのため
  userState = userState
  notificationState = notificationState
  examState = examState
  footerState = footerState
  examTestState = examTestState
  snackBarState = snackBarState
  menuState = menuState
  examResultState = examResultState
  subscriptionState = subscriptionState
  examMyState = examMyState


  get guestWarning() {
    return (this.user && this.user.isGuest && this.$route.name === ROUTER_NAME.HOME)
  }

  get unconfirmedEmail(){
    return this.user && this.user.unconfirmedEmail
  }

  get footerRender() {
    return footerState.dataRender
  }

  get snackbar() {
    return snackBarState.snackbar
  }

  get isOnBoarding(){
    return this.$route.name === ROUTER_NAME.ON_BOARDING
  }

  get isLoading() {
    switch (this.$route.name) {
      case ROUTER_NAME.EXAM_LIST:
        return examState.listExam.isLoading
      case ROUTER_NAME.MY_EXAM_LIST:
        return examMyState.isLoading || examTestState.isLoading
      case ROUTER_NAME.EXAM_RECOMMENDATION_LIST:
        return examState.listRecommendationExam.isLoading
      case ROUTER_NAME.SUBSCRIPTION:
        return subscriptionState.isLoading
      case ROUTER_NAME.SUBSCRIPTION_DETAIL:
        return subscriptionState.isLoading
      case ROUTER_NAME.ON_BOARDING:
        return userState.isLoading
      default:
        return examState.isLoading || examTestState.isLoading || snackBarState.isLoading || examResultState.isLoading
    }
  }

  get user() {
    return userState.user
  }

  get exam() {
    return examResultState.examResult
  }

  get answersFlowQuestion() {
    return this.exam.answersFlowQuestion(this.exam.userExam)
  }

  @Watch('user')
  watchUser(){
    if (this.user && this.user.userOnboard && this.$route.name !== ROUTER_NAME.ON_BOARDING) {
      this.$router.push({
        name: ROUTER_NAME.ON_BOARDING
      })
    }
  }

  @Watch('snackbar')
  changeSnackbar(val, oldVal) {
    this.show = val.open
  }

  @Watch('$route')
  changeRoute(val, oldVal) {
    if (oldVal.name == val.name) {
      if (val.params.questionId && this.mobile) {
        if (val.meta.transitionName == 'fade') {
          this.transitionName = 'fade'
        } else {
          if (parseInt(val.params.questionId) > parseInt(oldVal.params.questionId)) {
            this.transitionName = 'slide-left'
          } else {
            this.transitionName = 'slide-right'
          }
        }
      }
    }

    // キャッシュ防ぐために、Examじゃないページに移動したら、キャッシュを消す
    if (![
      ROUTER_NAME.EXAM_SHOW, 
      ROUTER_NAME.QUESTION, 
      ROUTER_NAME.EXAM_QUESTION_LIST,
      ROUTER_NAME.EXAM_RESULT,
      ROUTER_NAME.ANSWER_RESULT_DETAIL,
      ].indexOf(this.$route.name)) {
      examTestState.reset()
      examResultState.reset()
    }

    this.watchUser()
  }

  created() {
    userState.getUser()
    menuState.getMenus()
    notificationState.getNotification({ checkNotification: false })
    if (this.$route.name != ROUTER_NAME.EXAM_RECOMMENDATION_LIST) {
      examState.getRecommendationList()
    }
    this.mobile = checkMobile()

    const chanel = makeChannel(
      'NotificationChannel',
      () => {
        notificationState.getNotification({ checkNotification: false })
      },
      () => {
        chanel.send({
          action: 'follow'
        })
      }
    )

    this.$router.beforeEach((to, from, next) => {
      var transitionName = to.meta.transitionName || from.meta.transitionName

      if (transitionName === 'slide') {
        transitionName = to.meta.index < from.meta.index ? 'slide-right' : 'slide-left'
      }

      this.transitionName = transitionName || 'fade'
      next()
    })
  }

  closeSnackbar() {
    this.show = false
    snackBarState.setDefaultSnackbar()
  }

  isMeeting() {
    location.pathname.includes('meeting')
  }

}
